import { render, staticRenderFns } from "./DPIQuestion.vue?vue&type=template&id=82397e7e&"
import script from "./DPIQuestion.vue?vue&type=script&lang=js&"
export * from "./DPIQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports